import { render, staticRenderFns } from "./UnityVideoCall.vue?vue&type=template&id=39ff73dd&scoped=true&"
import script from "./UnityVideoCall.vue?vue&type=script&lang=js&"
export * from "./UnityVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./UnityVideoCall.vue?vue&type=style&index=0&id=39ff73dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ff73dd",
  null
  
)

export default component.exports